export enum webcastUrlType {
  CHANNEL_CUSTOM = 'CHANNEL_CUSTOM',
  CHANNEL_DEFAULT = 'CHANNEL_DEFAULT',
  WEBCAST_CUSTOM = 'WEBCAST_CUSTOM'
}
